import { useEffect, useRef } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { Box } from "@mui/material";
import { Loader } from "components";

const getBoundBox = (coordinates) => {
  const latLngs = coordinates.map((coord) => L.latLng(coord[1], coord[0])); // Note: [lat, lng]
  const bounds = L.latLngBounds(latLngs);

  return {
    minLat: bounds.getSouth(),
    maxLat: bounds.getNorth(),
    minLon: bounds.getWest(),
    maxLon: bounds.getEast(),
  };
};

const MapImageOverlay = ({
  coordinates,
  png,
  opacity = 100,
  hasOverlay = false,
  isLoading = false,
}) => {
  const map = useMap();
  const overlayRef = useRef();

  useEffect(() => {
    const pane = map.getPane("overlayPane");
    if (!pane) return;

    pane.style.mixBlendMode = hasOverlay ? "overlay" : "";

    return () => {
      if (pane) pane.style.mixBlendMode = "";
    };
  }, [map, hasOverlay]);

  useEffect(() => {
    if (overlayRef.current) {
      map.removeLayer(overlayRef.current);
    }
    if (png) {
      const boundBox = getBoundBox(coordinates);
      const indexLayer = L.imageOverlay(
        png,
        [
          [boundBox.maxLat, boundBox.minLon],
          [boundBox.minLat, boundBox.maxLon],
        ],
        { opacity: opacity * 0.01 }
      );

      indexLayer.addTo(map);
      overlayRef.current = indexLayer;
    }

    return () => {
      if (overlayRef.current) {
        map.removeLayer(overlayRef.current);
      }
    };
  }, [png, map, coordinates, opacity]);

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100px",
          width: "100px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
        }}
      >
        <Loader size={50} />
      </Box>
    );
  }

  return null;
};

export default MapImageOverlay;
